// Enum named exports read by @sendbird/uikit-react-native's recorder/player adapters
// (e.g. audioRecorderModule.AudioEncoderAndroidType.AAC). Values are inert on web.
export const AudioEncoderAndroidType = { AAC: 'aac' };
export const OutputFormatAndroidType = { MPEG_4: 'mpeg_4' };
export const AudioSourceAndroidType = { VOICE_RECOGNITION: 'voice_recognition' };
export const AVEncodingOption = { aac: 'aac', mp4: 'mp4' };
export const AVEncoderAudioQualityIOSType = { high: 'high', medium: 'medium', low: 'low' };
export const AVModeIOSOption = { measurement: 'measurement' };

export class HybridSound {
  play = () => {};
  stop = () => {};
  pause = () => {};
  load = (_url) => {};
  release = () => {};
}

export default class AudioRecorderPlayer {
  addPlayBackListener = (_cb) => {};
  removePlayBackListener = () => {};
  addRecordBackListener = (_cb) => {};
  removeRecordBackListener = () => {};
  startRecorder = () => Promise.resolve('');
  stopRecorder = () => Promise.resolve('');
  pauseRecorder = () => Promise.resolve('');
  resumeRecorder = () => Promise.resolve('');
  startPlayer = () => Promise.resolve('');
  stopPlayer = () => Promise.resolve('');
  pausePlayer = () => Promise.resolve('');
  resumePlayer = () => Promise.resolve('');
  seekToPlayer = () => Promise.resolve('');
  setVolume = () => Promise.resolve('');
  setSubscriptionDuration = () => Promise.resolve('');
  mmss = (ms) => {
    const sec = Math.floor(ms / 1000);
    return `${String(Math.floor(sec / 60)).padStart(2, '0')}:${String(sec % 60).padStart(2, '0')}`;
  };
}
